<template>
  <tr>
    <td>
      <div style="min-width: 200px">
        <a class="btn btn-danger m-0 customer-payin text-white" @click="openResellerAccount(customer.id)">
          <i class="fa fa-desktop"></i>
        </a>
        <router-link :to="{name: 'ResellerInfo', params: {id: customer.id}}" tag="a" class="btn btn-info m-0 text-white">
          <i class="fa fa-eye"></i>
        </router-link>
        <router-link :to="{name: 'CustomerList', query: {referer: customer.id}}" href="javascript:;" class="btn btn-info m-0 customer-payout text-white" @click="openPayinModal(customer.id, '-')">
          <i class="fa fa-user"></i>
        </router-link>
        <router-link :to="{name: 'ResellerList', query: {referer: customer.id}}" class="btn btn-info get-subdealers" title="Alt bayilerini göster">
          <i class="fa fa-angle-double-down"></i>
        </router-link>
      </div>
    </td>
    <td>
      <router-link :to="{name: 'CardBayi', query: {uid: customer.id, page: 1}}">
        {{ customer.username }}
      </router-link>
    </td>
    <td>
      {{ balance.casino_profit }}
    </td>
    <td>
      {{ balance.bet_profit }}
    </td>
    <td>
      {{ balance.card_balance }}
    </td>
    <td>
      {{ customer.balance }}
    </td>
  </tr>
</template>

<script>
export default {
  name: "ResellerTableRow",
  props: ['customer'],
  data () {
    return {
      balance: {}
    }
  },
  mounted() {
    this.fetchBalance()
  },
  methods: {
    fetchBalance(){
      this.$http.get(api + 'api/v1/reseller_giro/'+this.customer.id)
          .then(response => {
            this.balance = response.body.result.data;
          }, response => {

          })
    },
    openResellerAccount(uid) {
      this.createToken(uid)
    },
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/row/ResellerTableRow.vue